/* eslint-disable import/no-named-as-default-member */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import styled from "styled-components";
import { ACCESS_TYPE_PIPELINE_DEAL } from "../../../constants/accessTypes";
import { getPipelineActiveDealDetails } from "../../../store/state/deal";
import { updateProperty, createProperty, deleteProperty } from "../../../store/state/property";
import { getGuestsByDealId } from "../../../store/state/guest";
import DealAttachments from "../../Global/OptionsMenu/DealTable/DealAttachments";
import DealNotes from "../../Global/OptionsMenu/DealTable/DealNotes";
import GuestView from "../../GuestView";
import guestPermissionHelper from "../../../utils/guestPermissionHelper";
import LoanPrefTable from "../../Global/TablePreferenceColumns/LoanPrefTable";
import SeniorLoanTableColumns from "../../Global/TablePreferenceColumns/LoanTableColumns/SeniorLoanTableColumns";
import { getLoansByPreferenceAndLoanStatus } from "../../../store/state/loan/loan";
import loanStatuses from "../../../constants/loanStatuses";
import PipelineDealViewAndEdit from "./components/PipelineDealViewAndEdit";
import PassedAndRejectedQuotes from "./Quotes/PassedAndRejectedQuotes";
import PipelineActiveDealQuotes from "./Quotes/PipelineActiveDealQuotes";
import PipelineDealHeader from "./components/PipelineDealHeader";
import dealStatuses from "../../../constants/status";
import { getScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";

const PagePadding = styled.div`
  padding: 16px;
  max-width: 1400px;
  margin: 0 20px 250px 20px;
`;

const VerticalSpace = styled.div`
  height: ${props => props.val}px;
`;

const ExistingFinancingP = styled.p`
  margin-bottom: 10px;
  margin-top: 30px;
  width: 100%;
  color: #999999;
`;

class PipelineActiveDeal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpired: true,
      isAttachmentsOpen: false,
      isNotesOpen: false,
      refreshGrid: false,
      guestPermissions: { isGuest: false }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location && nextProps.location && this.props.location.pathname !== nextProps.location.pathname) {
      window.location.reload();
    }
  }

  componentDidMount() {
    const { dealId } = this.props.match.params;
    this.props.getPipelineActiveDealDetails({
      dealId,
      subKey: dealId
    });
    this.props.getGuestsByDealId({ dealId, accessTypeId: ACCESS_TYPE_PIPELINE_DEAL });

    this.props.getScreenPreferences({ screenType: "senior_loan_table" });
    this.props.getLoansByPreferenceAndLoanStatus({
      dealId,
      loanStatusId: loanStatuses.MODIFYING,
      page: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
      columns: [
        "loanProvider.name",
        "amount",
        "initialProceeds",
        "covenants.ltvStabilized",
        "loanTermMonths",
        "extensionTerms.extensionTermMonths",
        'loanPricing', 
        "currentRate",
        "amortizationTerm",
        "ioPeriod",
        'interestOnlyPayment', 
        "amortizingPayment", 
        "prefHedge.hedgeTypeId",
        'prefHedge.marketCost',
        'closingCosts.totalAmount',
        "loanRecourse.recourseType.name",
        "prepaymentTerms.prepaymentType.value",
        "covenants.dscrStabilized", 
        "covenants.debtYieldStabilized",
        'effectiveRate', 
        'averageProjectedRate', 
        "loanType.name", 
      ],
      includePassedRejected: false,
      subKey: "modifyingLoans"
    });
    this.props.getLoansByPreferenceAndLoanStatus({
      dealId,
      loanStatusId: loanStatuses.CLOSED_LOAN,
      page: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
      includePassedRejected: false,
      columns: [
        "loanProvider.name",
        "amount",
        "initialProceeds",
        "covenants.ltvStabilized",
        "loanTermMonths",
        "extensionTerms.extensionTermMonths",
        'loanPricing', 
        "currentRate",
        "amortizationTerm",
        "ioPeriod",
        'interestOnlyPayment', 
        "amortizingPayment", 
        "prefHedge.hedgeTypeId",
        'prefHedge.marketCost',
        'closingCosts.totalAmount',
        "loanRecourse.recourseType.name",
        "prepaymentTerms.prepaymentType.value",
        "covenants.dscrStabilized", 
        "covenants.debtYieldStabilized",
        'effectiveRate', 
        'averageProjectedRate', 
        "loanType.name", 
      ],
      subKey: "closedLoans"
    });
  }

  componentDidUpdate() {
    const shouldBuildGuestPermissions = guestPermissionHelper.shouldBuildGuestPermissions(
      this.props.authentication.guestAccess,
      this.props.deal,
      this.props.guestPermission,
      this.props.dealguests
    );

    if (shouldBuildGuestPermissions && !this.state.guestPermissions.isGuest) {
      const guestPermissions = guestPermissionHelper.buildGuestPermissions(
        this.props.authentication.guestAccess,
        this.props.deal,
        this.props.guestPermission,
        this.props.dealguests,
        "pipelinePermission",
        this.props.history
      );
      this.setState({ guestPermissions });
    }
  }

  onExpired = expiration => {
    this.setState({ isExpired: expiration });
  };

  modifyPropertyPercentages = property => {
    const modified = { ...property };
    if (modified.occupancy) modified.occupancy /= 100;
    return modified;
  };

  deleteFalsyValues = property => {
    this.deleteIfFalsy(property, "squareFeet");
    this.deleteIfFalsy(property, "units");
    this.deleteIfFalsy(property, "yearBuilt");
    this.deleteIfFalsy(property, "yearRenovated");
    this.deleteIfFalsy(property, "salesPrice");
    this.deleteIfFalsy(property, "noi");
    this.deleteIfFalsy(property, "noiActual");
    this.deleteIfFalsy(property, "appraisedValue");
    this.deleteIfFalsy(property, "purchasePrice");
    this.deleteIfFalsy(property, "landSize");
    this.deleteIfFalsy(property, "occupancy");
    this.deleteIfFalsy(property, "capExImprovements");
    this.deleteIfFalsy(property, "projectedExitDate");
    this.deleteIfFalsy(property, "actualExitDate");
    this.deleteIfFalsy(property, "purchaseDate");
    this.deleteIfFalsy(property, "noiAsOfDate");
    this.deleteIfFalsy(property, "marketValue");
    this.deleteIfFalsy(property, "marketValueAsOfDate");
    this.deleteIfFalsy(property, "noiAsOfappraisedValueAsOfDateDate");
  };

  deleteIfFalsy(property, fieldName) {
    if (!property[fieldName] && property[fieldName] !== 0) property[fieldName] = null;
  }

  onAddProperty = property => {
    const { dealId } = this.props.match.params;
    this.deleteFalsyValues(property);
    const modifiedProperty = this.modifyPropertyPercentages(property);
    this.props.createProperty({
      dealId,
      ...modifiedProperty,
      callback: () => {
        this.props.getPipelineActiveDealDetails({
          dealId,
          subKey: dealId
        });
      }
    });
  };

  onDeleteProperty = propertyId => {
    const { dealId } = this.props.match.params;
    this.props.deleteProperty({
      id: propertyId,
      callback: () => {
        this.props.getPipelineActiveDealDetails({
          dealId,
          subKey: dealId
        });
      }
    });
  };

  onEditProperty = property => {
    const { dealId } = this.props.match.params;
    this.deleteFalsyValues(property);
    const modifiedProperty = this.modifyPropertyPercentages(property);

    this.props.updateProperty({
      dealId,
      ...modifiedProperty,
      callback: () => {
        this.props.getPipelineActiveDealDetails({
          dealId,
          subKey: dealId
        });
      }
    });
  };

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  refreshDeal = () => {
    const { dealId } = this.props.match.params;
    this.props.getPipelineActiveDealDetails({
      dealId,
      subKey: dealId
    });
  };

  refreshGridCallback = () => {
    this.setState({ refreshGrid: true });
    this.refreshDeal();
  };

  gridRefreshedCallback = () => {
    this.setState({ refreshGrid: false });
  };

  hasExistingFinancing = () => {
    const dealId = this.props.match.params.dealId;
    if (this.props.dealDetails && this.props.dealDetails[dealId]) {
      const dealStatusId = this.props.dealDetails[dealId].data.dealStatus.id;
      return dealStatusId === dealStatuses.REFINANCE || dealStatusId === dealStatuses.ADDING_SUPPLEMENTAL || dealStatusId === dealStatuses.MODIFYING;
    }
    return false;
  };

  render() {
    const { match, dealDetails, isNewDeal, isInitialized, defaultValue, authentication } = this.props;

    const { isAttachmentsOpen, isNotesOpen, isExpired } = this.state;

    const { dealId } = match.params;
    if (!dealDetails) {
      return null;
    }

    const activeDeal = dealDetails[dealId] || { data: {} };
    if (activeDeal.isAuthorized !== undefined && !activeDeal.isAuthorized) {
      this.props.history.push("/AccessDenied");
    }
    const activeDealData = activeDeal.data;
    if(!activeDealData) return null;

    const dealStatusId = this.props.dealDetails && this.props.dealDetails[dealId] && this.props.dealDetails[dealId].data.dealStatus.id;
    
    return (
      <>
        <>
          <DealAttachments dealId={dealId} isOpen={isAttachmentsOpen} openAttachments={this.openAttachments} closeAttachments={this.closeAttachments} />
          <DealNotes dealId={dealId} isOpen={isNotesOpen} openNotes={this.openNotes} closeNotes={this.closeNotes} />
        </>
        <PagePadding>
          <PipelineDealHeader dealId={dealId} deal={activeDealData} guestPermissions={this.state.guestPermissions} />
          {!this.hasExistingFinancing() && <VerticalSpace val={16} />}
          <PipelineActiveDealQuotes
            history={this.props.history}
            deal={activeDealData}
            dealId={dealId}
            isExpired={isExpired}
            onExpired={this.onExpired}
            refreshGridCallback={this.refreshGridCallback}
            guestPermissions={this.state.guestPermissions}
            existingFinancing={this.props.existingLoansData}
          />
          {activeDealData.dealStatusId && activeDealData.dealStatusId !== dealStatuses.MODIFYING && (!authentication.isGuest || this.state.guestPermissions.pipelineAllowQuoteStatus) && (
            <>
              <VerticalSpace val={32} />
              <PassedAndRejectedQuotes
                deal={activeDeal}
                dealId={dealId}
                isExpired={isExpired}
                onExpired={this.onExpired}
                refreshGrid={this.state.refreshGrid}
                gridRefreshedCallback={this.gridRefreshedCallback}
                guestPermissions={this.state.guestPermissions}
              />
            </>
          )}
          {this.hasExistingFinancing() && (
            <>
              {activeDealData.dealStatusId && activeDealData.dealStatusId !== dealStatuses.MODIFYING && (
                <>
                  <VerticalSpace val={20} />
                  <hr />
                </>
              )}
              <ExistingFinancingP>EXISTING FINANCING</ExistingFinancingP>
              <LoanPrefTable
                isExpired={false}
                setExpired={() => {}}
                screenType="senior_loan_table"
                tableScreenElements={SeniorLoanTableColumns}
                shouldHideExport
                screenPreferences={this.props.existingFinancingPrefs}
                getData={() => {}}
                tableData={this.props.existingLoansData}
                dealId={dealId}
                downloadLoans={() => {}}
                shouldHideOptionsMenu
                shouldHidePageControls
              />
            </>
          )}
          <VerticalSpace val={32} />
          <hr />
          <VerticalSpace val={32} />

          <PipelineDealViewAndEdit
            deal={activeDealData}
            dealId={dealId}
            isNewDeal={isNewDeal}
            isInitialized={isInitialized}
            handleChange={this.handleChange}
            handleTextChange={this.handleTextChange}
            defaultValue={defaultValue}
            onAddProperty={this.onAddProperty}
            onEditProperty={this.onEditProperty}
            onDeleteProperty={this.onDeleteProperty}
            openNotes={this.openNotes}
            openAttachments={this.openAttachments}
            refreshDeal={this.refreshDeal}
            guestPermissions={this.state.guestPermissions}
          />
          {!authentication.isGuest && <GuestView dealId={dealId} isPipeline accessTypeId={ACCESS_TYPE_PIPELINE_DEAL} />}
        </PagePadding>
      </>
    );
  }
}

const modifyPercentages = pipelineActiveDealDetails => {
  if (_.isEmpty(pipelineActiveDealDetails)) return {};
  for (const key in pipelineActiveDealDetails) {
    if (pipelineActiveDealDetails.hasOwnProperty(key)) {
      const dealDetails = pipelineActiveDealDetails[key];
      if (_.isEmpty(dealDetails.data)) return pipelineActiveDealDetails;
      if (_.isEmpty(dealDetails.data.properties)) return pipelineActiveDealDetails;
      for (let i = 0; i < dealDetails.data.properties.length; i++) {
        const property = dealDetails.data.properties[i];
        if (property.occupancy && property.occupancy < 1) property.occupancy *= 100;
      }
    }
  }
  return pipelineActiveDealDetails;
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { dealId }
    }
  }
) => {
  const { authentication, deal, guest, screenPreferences, loan } = state;

  let existingLoansData;
  if (
    deal.pipelineActiveDealDetails[dealId] &&
    deal.pipelineActiveDealDetails[dealId].data &&
    deal.pipelineActiveDealDetails[dealId].data.dealStatusId === dealStatuses.MODIFYING
  ) {
    existingLoansData = loan.loansByPreference.modifyingLoans || {};
  } else if (loan.loansByPreference.closedLoans) {
    existingLoansData = loan.loansByPreference.closedLoans || {};
  } else {
    existingLoansData = {};
  }

  return {
    authentication,
    dealDetails: modifyPercentages(deal.pipelineActiveDealDetails),
    dealguests: guest.dealguests ? guest.dealguests[dealId] : [],
    guestPermission: guest.guestPermission ? guest.guestPermission : null,
    existingFinancingPrefs: screenPreferences.screen_pref.senior_loan_table || [],
    existingLoansData
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getPipelineActiveDealDetails,
    updateProperty,
    createProperty,
    deleteProperty,
    getGuestsByDealId,
    getLoansByPreferenceAndLoanStatus,
    getScreenPreferences
  })
)(PipelineActiveDeal);
